import { render, staticRenderFns } from "./GoogleRecaptcha.vue?vue&type=template&id=9fc08bce&"
import script from "./GoogleRecaptcha.vue?vue&type=script&lang=js&"
export * from "./GoogleRecaptcha.vue?vue&type=script&lang=js&"
import style0 from "./GoogleRecaptcha.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports